import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MobileCarouselBanner from '../../sliders/Mobile';
const SignUp = ({slidersMain}) => {
    const referralCode = localStorage.getItem('referral_code');
    const agentCode = localStorage.getItem('agent_code');
    const affiliateCode = localStorage.getItem('affiliate_code');
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        phone: '',
        referral_code: '',
        agent_code: agentCode || '',
        currency: 'BDT',
        status: 'active',
    });

    const [errors, setErrors] = useState({});
    const [passwordShown, setPasswordShown] = useState(false);
    // confirm password removed from signup
    
    useEffect(() => {
        
        if (referralCode) {
            setFormData(prevData => ({ ...prevData, referral_code: referralCode }));
        }else{
            setFormData(prevData => ({ ...prevData, referral_code: affiliateCode }));
        }
    }, [referralCode, affiliateCode]);

    const togglePasswordVisibility = () => setPasswordShown(!passwordShown);
    // confirm password removed from signup

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let tempErrors = {};
        const usernamePattern = /^[a-zA-Z0-9]+$/;
        const phonePattern = /^[0-9]{10,15}$/;
        const passwordPattern = /^[a-zA-Z0-9]+$/; // Alphanumeric characters only (no special characters)

        // Username validation
        if (!formData.username) tempErrors.username = "Username is required";
        else if (!usernamePattern.test(formData.username)) tempErrors.username = "Invalid username (only letters and numbers)";

		if (formData.username.length < 8 || formData.username.length > 16) { 
			tempErrors.username = "Username must be between 8 and 16 characters";
		}

        // Phone number validation
        if (!formData.phone) tempErrors.phone = "Phone number is required";
        else if (!phonePattern.test(formData.phone)) tempErrors.phone = "Invalid phone number (10-15 digits)";


        // Password validation
        if (!formData.password) tempErrors.password = "Password is required";
        else if (formData.password.length < 8) tempErrors.password = "Password must be at least 8 characters";
        else if (!passwordPattern.test(formData.password)) tempErrors.password = "Password can only contain letters and numbers (no special characters)";

        // Confirm password removed

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'signup_button_click',
    category: 'User Signup',
    action: 'Click',
    label: 'Signup Button'
  });
        e.preventDefault();
    
        if (validate()) {
            try {
                // Build payload; name/email not collected on signup
                const payload = { ...formData };
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-players`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Origin': window.location.origin,
                    },
                    body: JSON.stringify(payload),
                    
                });
    
                // Parse response
                const data = await response.json();
    
                // Handle response status
                if (response.ok) {
                    // Auto login after signup
                    const loginResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            username: formData.username,
                            password: formData.password,
                        }),
                    });
                
                    const loginData = await loginResponse.json();
                
                    if (loginResponse.ok) {
                        // Save login data
                        localStorage.setItem('token', loginData.token);
                        localStorage.setItem('remote_id', loginData.remote_id);
                        localStorage.setItem('username', loginData.username);
                        if (data.exchange?.[0]?.token) {
                localStorage.setItem('exchangeToken', data.exchange[0].token);
                } else {
                    localStorage.removeItem('exchangeToken');
                }
                        localStorage.setItem('popup', 1);
						localStorage.setItem('regPopup', 1);
						
						localStorage.removeItem('agent_code');
                        localStorage.removeItem('referral_code');
                        localStorage.removeItem('affiliate_code');
                
                        // Redirect to home
                        window.location.href = '/';
					} else {
						setErrors({ general: loginData.message });
                        console.error("Auto login failed:", loginData.message);
                    }
                } else {
                    console.error("Server validation errors:", data);
					// Update errors with server response
					let msg = data?.message || "Submission failed";
                    setErrors(data.errors || { general: msg });
                }
            } catch (error) {
                console.error("Error during signup:", error);
                setErrors({ general: "Network error, please try again" });
            }
        } else {
            console.log("Form has errors. Please fix them and try again.");
            console.error(errors)
        }
    };
    

    return (
        <div className="main-router-wrapper ng-trigger ng-trigger-routeFullPageAni">
            <header className="ng-star-inserted member">
                <div className="header-left-btn-group">
                    <Link to={'/'}>
                        <div
                            className="back-btn ng-star-inserted"
                            style={{
                                maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1729676340443")',
                            }}
                        />
                    </Link>
                </div>
                <div className="header-title ng-star-inserted">Sign up</div>
            </header>
            <div className="wrap">
                <div className="content member-content normal-register">
                    <div className="ng-trigger ng-trigger-routeLayoutPageAni">
                        <div className="ng-star-inserted">
                            <MobileCarouselBanner slidersMain={slidersMain || []}/>
                            <div className="inner-wrap">
								<div className="inner-box">
									{errors.general && <div className="member-error"><span> {errors.general} </span></div>}
                                    <form onSubmit={handleSubmit} noValidate className="ng-untouched ng-pristine ng-invalid">
                                        <div className="member-box radius">
                                            <div className="inputbox-wrapper">
                                                <div className="inputbox error">
                                                    <label>Username</label>
                                                    <input
                                                        name="username"
                                                        type="text"
                                                        className="input ng-untouched ng-pristine ng-invalid"
                                                        placeholder="8-16 char, allow number & letter"
                                                        value={formData.username}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                
                                                {errors.username && <div  className="member-error"><span> {errors.username} </span></div>}
                                            </div>
                                            <div className="inputbox-wrapper">
                                                <div className="inputbox password">
                                                <div
                                                        className={`eyes ${passwordShown ? 'active' : ''}`}
                                                        onClick={togglePasswordVisibility}
                                                    />
                                                    <label>Password</label>
                                                    <input
                                                        name="password"
                                                        type={passwordShown ? "text" : "password"}
                                                        className="input ng-untouched ng-pristine ng-invalid"
                                                        placeholder="8-20 Characters and Numbers"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                
                                                {errors.password && <div  className="member-error"><span> {errors.password} </span></div>}
                                            </div>
                                            {/* Confirm Password removed; Currency selection removed */}
                                            </div>
                                        <div className="member-box radius">
                                            {/* Full Name removed from signup */}
                                            <div className="inputbox-wrapper">
                                                <div className="inputbox phone">
                                                    <label>Phone Number</label>
                                                    <div className="phone-area-code">
                                                        <div className="lang-select">
                                                            <button className="btn-select only">
                                                                <li><span>+88</span></li>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <input
                                                        name="phone"
                                                        type="text"
                                                        className="input ng-untouched ng-pristine ng-invalid"
                                                        placeholder="Phone Number"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                
                                                {errors.phone && <div  className="member-error"><span> {errors.phone} </span></div>}

                                            </div>
                                            {/* Email removed from signup */}
                                            <div className="inputbox-wrapper">
                                                <div className="inputbox ng-star-inserted">
                                                    <label>Referral Code</label>
                                                    <input
                                                        name="referral_code"
                                                        type="text"
                                                        className="input ng-untouched ng-pristine ng-valid"
                                                        placeholder="Enter if you have one"
                                                        value={formData.referral_code}
                                                        readOnly={!!formData.agent_code}
                                                        onChange={handleChange}
                                                    />
                                                     <input
                                                        name="agent_code"
                                                        type="hidden"
                                                        value={formData.agent_code}    
                                                    />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <button className="button">
                                            SUBMIT
                                        </button>
                                        <p>I'm 18 years old, and agree to "terms and conditions".</p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignUp;
